import { getFileType } from './fileUploadUtils';

async function b64toBlob(b64Data: string, sliceSize = 512): Promise<Blob> {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: await getFileType(new Blob(byteArrays)) });
}

export const displayPDF = async (val: string, defaultName?: string): Promise<void> => {
  const file = await b64toBlob(val);
  // If the browser is IE or Edge
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file, defaultName ? `${defaultName}.pdf` : 'document.pdf');
  } else {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }
};
export const displayDocument = async (document: string | File): Promise<void> => {
  // File comes from UploadDocument Forms
  // string comes from TableRow
  const fileURL =
    typeof document === 'string'
      ? URL.createObjectURL(await b64toBlob(document))
      : URL.createObjectURL(document);

  window.open(fileURL);
};

export const scrollTo = (x: number, y: number): void => {
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth',
  });
};

export default displayPDF;
